module.exports = "/_next/static/images/HCGO_Mini_Web-Banner-fefedbfe03e39a01f769f8d1cd17649c.jpg";